import './styles.scss'

import { useTranslation } from 'react-i18next';

import { Button } from "@fragments";
import { IconHelp, IconLogout, IconDownload, IconMoon, IconSun } from "@tabler/icons-react";

import Notifications from "@components/Screen/Header/Notifications";

import { useScreen } from "@hooks/useScreen";
import { useDownloadApp } from '@features/downloadApp';
import { useSidebar } from '../../Sidebar/SidebarContext';

import CreateButton from './CreateButton';

import config from '@config';

export default function Actions() {
    const { t } = useTranslation('shell');
    const { isMobile } = useSidebar();
    const { resolvedAppearance, setAppearance } = useScreen();
    const downloadApp = useDownloadApp();

    return (
        <div className="cs-header-actions">
            {!isMobile && <CreateButton />}

            {!isMobile && <Notifications />}

            {isMobile && (
                <Button
                    color="overlay"
                    variant="rounded"
                    icon={resolvedAppearance === 'dark' ? <IconMoon /> : <IconSun />}
                    onClick={() => setAppearance(resolvedAppearance === 'dark' ? 'light' : 'dark')}
                    tooltip={t('actions.changeTheme')}
                />
            )}

            {/* QR modal on a computer, the device's own store on a phone. */}
            <Button
                color="overlay"
                variant="rounded"
                icon={<IconDownload />}
                onClick={downloadApp.open}
                tooltip={t('actions.downloadApp')}
                preventLoading
            />

            <Button
                color="overlay"
                variant="rounded"
                icon={<IconHelp />}
                onClick={() => {
                    window.open(config.help)
                }}
                tooltip={t('actions.help')}
            />

            {!isMobile && (
                <Button
                    onClick={() => window.logout()}
                    variant="rounded"
                    color="overlay"
                    endIcon={<IconLogout />}
                    tooltip={t('actions.logoutTooltip')}
                >
                    {t('actions.logout')}
                </Button>
            )}
        </div>
    )
}
